export const POLLING_INTERVAL = 5000;
